import { Link } from 'react-router-dom';
import { ShoppingBag, Cpu, Monitor, Laptop, HardDrive, MemoryStick } from 'lucide-react';
import { AliExpressProducts } from '../components/home/AliExpressProducts';

// AliExpress categories for homepage
const HOME_CATEGORIES = [
  { id: 'cpu', slug: 'cpu', name: 'CPU', icon: 'Cpu' },
  { id: 'gpu', slug: 'gpu', name: '그래픽카드', icon: 'Monitor' },
  { id: 'laptops', slug: 'laptops', name: '노트북', icon: 'Laptop' },
  { id: 'ssd', slug: 'ssd', name: 'SSD', icon: 'HardDrive' },
  { id: 'ram', slug: 'ram', name: 'RAM', icon: 'MemoryStick' },
  { id: 'monitors', slug: 'monitors', name: '모니터', icon: 'Monitor' },
];

// Icon mapping
const getIcon = (iconName: string) => {
  const icons: Record<string, React.ReactNode> = {
    Cpu: <Cpu size={24} />,
    Monitor: <Monitor size={24} />,
    Laptop: <Laptop size={24} />,
    HardDrive: <HardDrive size={24} />,
    MemoryStick: <MemoryStick size={24} />,
  };
  return icons[iconName] || <Cpu size={24} />;
};

export function HomePage() {
  return (
    <div className="container py-6">
      {/* Header Banner */}
      <section className="mb-8">
        <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-xl p-6 text-white">
          <div className="flex items-center justify-between flex-wrap gap-4">
            <div>
              <h1 className="text-2xl font-bold mb-1">
                컴퓨터 부품 최저가 비교
              </h1>
              <p className="text-orange-100 text-sm">
                알리익스프레스 해외 직구 최저가
              </p>
            </div>
            <Link
              to="/categories"
              className="flex items-center gap-2 px-5 py-2.5 bg-white text-orange-600 rounded-lg font-medium hover:bg-orange-50 transition-colors"
            >
              <ShoppingBag size={18} />
              전체 카테고리
            </Link>
          </div>
        </div>
      </section>

      {/* AliExpress Hot Products */}
      <AliExpressProducts />

      {/* Quick Category Links */}
      <section className="mb-8">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-bold text-gray-900">카테고리</h2>
          <Link
            to="/categories"
            className="text-orange-600 hover:text-orange-700 text-sm font-medium"
          >
            전체 보기 &rarr;
          </Link>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-6 gap-3">
          {HOME_CATEGORIES.map((category) => (
            <Link
              key={category.id}
              to={`/categories/${category.slug}`}
              className="flex flex-col items-center p-4 bg-white rounded-lg border border-gray-200 hover:shadow-md hover:border-orange-300 transition-all group"
            >
              <div className="w-12 h-12 bg-gradient-to-br from-orange-100 to-red-100 rounded-xl flex items-center justify-center text-orange-600 mb-2 group-hover:from-orange-200 group-hover:to-red-200 transition-colors">
                {getIcon(category.icon)}
              </div>
              <span className="text-sm font-medium text-gray-900 text-center group-hover:text-orange-600 transition-colors">
                {category.name}
              </span>
            </Link>
          ))}
        </div>
      </section>

      {/* Info Banner */}
      <section className="mb-8">
        <div className="p-6 bg-gradient-to-r from-orange-50 to-red-50 rounded-xl border border-orange-200">
          <h3 className="text-lg font-semibold text-gray-900 mb-3">
            🛒 쇼핑 안내
          </h3>
          <div className="grid md:grid-cols-2 gap-4">
            <div className="text-gray-600 text-sm leading-relaxed">
              <h4 className="font-medium text-gray-900 mb-1">🛍️ 알리익스프레스</h4>
              <p>해외 직구로 저렴한 가격! 한국 직배송 가능한 제품들. 관부가세는 $150(미국)/$200(중국) 초과 시 부과됩니다.</p>
            </div>
            <div className="text-gray-600 text-sm leading-relaxed">
              <h4 className="font-medium text-gray-900 mb-1">🚀 쿠팡 로켓배송</h4>
              <p>빠른 배송과 안전한 국내 쇼핑! 로켓배송 제품은 익일~2일 내 도착. 파트너스 제휴 링크를 통해 연결됩니다.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
